import { IAdresse } from 'components/AddressTypeahead/types';
import { AddressSearchResult } from 'services/KjederegisteretAdminApi/AdresseApi/types';
import { EndringsMelding, QaAddress } from 'services/QAApi/types';

export class ChangeRequestValidator {
  static hasNedlagtDatoErrors = (nedlagtDato: Date): string | null => {
    if (!nedlagtDato || isNaN(nedlagtDato.getTime())) {
      return 'NedlagtDato må være en gyldig dato.';
    }
    return null;
  };

  static hasLeverandorKundenummerErrors = (leverandorKundenummer: string): string | null => {
    return null;
  };

  static isGlnValid = (gln: string, changeRequest: EndringsMelding) => {
    if (!gln) return false;
    if (
      changeRequest.sentBySystem === 'GlnApi' ||
      changeRequest.sentBy === 'GlnSnitch' ||
      changeRequest.sentBy === 'GlnApi' ||
      changeRequest.sentBy === 'Salgsdata'
    ) {
      return true;
    }
    return false;
  };

  static isOrganisasjonsnrValid = (organisasjonsnr: string) => {
    // Add validation logic for Organisasjonsnummer if needed
    return !!organisasjonsnr && organisasjonsnr.length > 0;
  };

  static hasTelephoneErrors = (telephone: string): string | null => {
    // Er dette et norsk telefonnummer?
    if (telephone.length !== 8) {
      return 'Telefonnummeret må være 8 siffer langt.';
    }
    return null;
  };

  static hasFakturaEpostErrors = (fakturaEpost: string): string | null => {
    if (!EmailValidator.isValidEmail(fakturaEpost)) {
      return 'Faktura e-post må være en gyldig e-postadresse.';
    }
    return null;
  };

  static hasEpostErrors = (epost: string): string | null => {
    if (!EmailValidator.isValidEmail(epost)) {
      return 'E-post må være en gyldig e-postadresse.';
    }
    return null;
  };

  static hasHomepageErrors = (homepage: string): string | null => {
    if (!UrlValidator.isValidUrl(homepage)) {
      return 'Hjemmeside må være en gyldig URL.';
    }
    return null;
  };

  static hasOmsetningErrors = (omsetning: number): string | null => {
    if (omsetning < 0) {
      return 'Omsetning må være et positivt tall.';
    }
    return null;
  };

  static hasKontonummerErrors = (kontonummer: string): string | null => {
    if (!kontonummer || kontonummer.length !== 11) {
      return 'Kontonummer må være 11 siffer langt.';
    }

    // Kan også legge til en sjekk for gyldighet av kontonummerformatet

    return null;
  };

  static hasSalgsarealErrors = (salgsareal: number): string | null => {
    if (salgsareal < 0) {
      return 'Salgsareal må være et positivt tall.';
    }
    return null;
  };

  static hasOppstartsDatoErrors = (oppstartsDato: Date): string | null => {
    if (!oppstartsDato || isNaN(oppstartsDato.getTime())) {
      return 'Oppstartsdato må være en gyldig dato.';
    }
    return null;
  };

  static hasGrossistKundenummerErrors = (
    grossistKundenummer: string,
    grossistGln: string,
  ): string | null => {
    if (!grossistKundenummer || grossistKundenummer.length === 0) {
      return 'Grossist kundenummer må være oppgitt.';
    }
    if (!grossistGln || grossistGln.length === 0) {
      return 'Grossist GLN må være oppgitt.';
    }
    return null;
  };

  static hasBesoksAdresseErrors = (
    besoksAdresse: IAdresse,
    lookupResults: AddressSearchResult[],
  ): string | null => {
    if (!besoksAdresse) {
      return 'Besøksadresse må være oppgitt.';
    }
    if (!besoksAdresse.gateadresse || besoksAdresse.gateadresse.length === 0) {
      return 'Besøksadresse må ha en gyldig adresse.';
    }
    if (!besoksAdresse.postnr || besoksAdresse.postnr.length !== 4) {
      return 'Besøksadresse må ha et gyldig postnummer.';
    }
    if (!besoksAdresse.poststed || besoksAdresse.poststed.length === 0) {
      return 'Besøksadresse må ha et gyldig poststed.';
    }

    // does address exist in lookup results?
    const addressExists = lookupResults.some(
      (result) =>
        result.gateadresse?.toUpperCase() === besoksAdresse.gateadresse?.toUpperCase() &&
        result.postnr?.toUpperCase() === besoksAdresse.postnr?.toUpperCase() &&
        result.poststed?.toUpperCase() === besoksAdresse.poststed?.toUpperCase(),
    );
    if (!addressExists) {
      return 'Besøksadresse finnes ikke i systemet.';
    }

    return null;
  };
}

export class EmailValidator {
  static isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
}

export class UrlValidator {
  static isValidUrl = (url: string): boolean => {
    if (!url) return false;
    // Accept with or without protocol; basic domain.tld pattern with optional path/query
    const withProtocol = /^(https?:\/\/)[\w.-]+\.[A-Za-z]{2,}(?:[\/:?#][^\s]*)?$/i;
    const withoutProtocol = /^[\w.-]+\.[A-Za-z]{2,}(?:[\/:?#][^\s]*)?$/i;
    return withProtocol.test(url) || withoutProtocol.test(url);
  };
}
